var render = function render(){var _vm=this,_c=_vm._self._c;return (
    _vm.item[_vm.tableHeader.value].ShowAsLabel &&
    _vm.item[_vm.tableHeader.value].LabelHasColor &&
    _vm.value
  )?_c('v-chip',{attrs:{"color":_vm.item[_vm.tableHeader.value].LabelColor,"text-color":_vm.item[_vm.tableHeader.value].TextColorWhite ? 'white' : '',"dense":""}},[_vm._v(" "+_vm._s(_vm.value)+" ")]):(_vm.item[_vm.tableHeader.value].ShowAsLabel && _vm.value)?_c('v-chip',{attrs:{"dense":""}},[_vm._v(" "+_vm._s(_vm.value)+" ")]):_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.value)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }